import type { FC } from 'react';

import { Sidebar } from '../Sidebar';

import type { TAppShellProps } from './AppShell.props';

const AppShell: FC<TAppShellProps> = ({
  persona, name, sections, children, onSignOut,
}) => (
  <div className="bg-bg-canvas flex h-screen items-start">
    <Sidebar persona={persona} name={name} sections={sections} onSignOut={onSignOut} />
    <main className="flex h-full min-w-0 flex-1 flex-col overflow-y-auto">
      {children}
    </main>
  </div>
);

export {
  AppShell,
};
